// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0.1.0/css/" + chunkId + "." + {"173":"1992421b","310":"da7c61bd","770":"b02b85d3"}[chunkId] + ".css";
};